import getCalendarEventsForRange from './getCalendarEventsForRange';
import { OwaDate, getTimestamp } from 'owa-datetime';
import { getCalendarEventsCountIndex } from '../store/store';

/**
 * Returns the number of calendar events for a given date range
 * @param dateRange Date Range
 */
export default async function getCalendarEventsCountsForADateRange(
    startDate: OwaDate,
    endDate: OwaDate
): Promise<Map<OwaDate, number>> {
    try {
        // Make sure that the calendar events for the requested date range are added to the cache
        await getCalendarEventsForRange({
            start: getTimestamp(startDate),
            end: getTimestamp(endDate),
        });
    } catch (error) {
        return Promise.reject(error);
    }

    return getCalendarEventsCountIndex().getEventsCountForDateRange(startDate, endDate);
}
